module.exports = __webpack_public_path__ + "cf311747.svg";